function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPerson = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  fill: "none",
  viewBox: "0 0 17.02 20"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M18 7.75V5.583a4.254 4.254 0 0 0-1.318-3.064A4.59 4.59 0 0 0 13.5 1.25H5.625a4.59 4.59 0 0 0-3.182 1.27 4.254 4.254 0 0 0-1.318 3.063V7.75",
  style: {
    fill: "none"
  },
  transform: "translate(-.113 12.026) scale(.9017)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M5.563 9.917c2.485 0 4.5-1.94 4.5-4.334 0-2.393-2.015-4.333-4.5-4.333-2.486 0-4.5 1.94-4.5 4.333 0 2.394 2.014 4.334 4.5 4.334z",
  style: {
    fill: "none"
  },
  transform: "translate(3.295 -.234) scale(.9375)"
}));
export default SvgPerson;